<template>
  <div class="day-event has-bg-white" :class="{'is-opened': isOpen}">
    <div class="columns">
      <div class="column is-narrow is-padding-right-large has-text-right is-border-right">
        <div class="columns">
          <p class="is-margin-top-xsmall has-text-centered">
            <time :datetime="date.format('DD-MMMM-YYYY')">
              <b>{{event.date|prettyHour}}</b>
            </time>
          </p>
          <span class="dot is-medium has-bg-danger">
          </span>
        </div>
      </div>
      <div class="column is-flex is-padding-small">
        <div class="is-self-centered is-padding-left-xsmall">
          Rappel : " <span class="has-text-weight-bold ">{{event.title}}</span> "
        </div>
      </div>
      <div class="column is-narrow is-self-centered actions">
        <div class="field is-grouped">
          <div class="control is-relative">
            <div class="dropdown is-hoverable is-right">
              <div class="dropdown-trigger">
                <button aria-haspopup="true" aria-controls="dropdown-menu" class="button is-white is-small is-circle">
                  <span class="icon is-small is-size-4"><i class="far fa-ellipsis-v"></i></span>
                </button>
              </div>
              <div id="dropdown-menu" role="menu" class="dropdown-menu">
                <div class="dropdown-content has-text-left">
                  <a class="dropdown-item" @click="editReminder">
                    <span class="icon"><i class="fas fa-pencil"></i></span><span>Modifier rappel</span>
                  </a>
                  <a @click="deleteEvent" class="dropdown-item">
                    <span class="icon"><i class="fas fa-trash"></i></span><span>Supprimer rappel</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CalendarReminderItem',
    props: {
      event: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      isOpen: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        eventDate: null,
        configDate: {
          altInput: true,
          altFormat: 'j M Y H:i',
          dateFormat: 'Z',
          time_24hr: true,
          enableTime: true
        }
      }
    },
    filters: {
      prettyHour (val) {
        return moment(val).format('HH:mm')
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'currentUserPk']),
      isReminder () {
        return this.type === 'REMINDER'
      },
      date () {
        let date = moment(this.event.date)

        if (date && date.isValid()) {
          return date
        } else {
          return null
        }
      }
    },
    methods: {
      editReminder () {
        let params = {
          source: this.event
        }
        this.$store.commit('setQuickview', {mode: 'EDIT_REMINDER', params})
      },
      // openEvent () {
      //   if (!this.editReminder) {
      //     this.editReminder = true
      //     this.$emit('openEvent', this.event)
      //   } else this.closeEvent()
      // },
      // closeEvent () {
      //   if (this.editReminder) {
      //     this.editReminder = false
      //     this.$emit('openEvent', null)
      //   } else this.openEvent()
      // },
      deleteEvent () {
        console.log('coucou ?')
        this.confirmDelete().then(r => {
          console.log(r)
          if (r.value) {
            const eventPk = this.event.pk
            let key = moment(this.event.date).format('DD/MM/YYYY')
            this.$api.reminderService.delete(this.event.pk).then(r => {
              this.$notify({type: 'is-success', text: 'Le rappel a été supprimé'})
              this.$store.commit('removeCalendarEvent', {eventPk, key, type: 'reminders'})
              if (this.event.google_event_id) {
                this.removeRdvInGoogle(this.event)
              }
            }).catch(() => {
              this.$notify({
                type: 'is-danger',
                text: 'Erreur lors de la suppression'
              })
            })
          }
        })
      },
      confirmDelete () {
        return this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ce rappel ?',
          confirmButtonText: 'Supprimer'
        })
      }
      // updateReminder () {
      //   this.editReminder = false
      //   this.event.date = moment.utc(this.eventDate).format('DD/MM/YYYY HH:mm')
      //   let eventPk = this.event.pk
      //   this.$api.reminderService.put(eventPk, this.event).then(r => {
      //     this.$emit('openEvent', null)
      //     let reminder = r.data
      //     this.eventDate = new Date(reminder.date)
      //     let key = moment(reminder.date).format('DD/MM/YYYY')
      //     this.$store.commit('removeCalendarEvent', {
      //       eventPk,
      //       type: 'reminders'
      //     })
      //     this.$store.commit('addCalendarEvent', {event: reminder, key, type: 'reminders'})
      //     this.$notify({
      //       type: 'is-success',
      //       text: 'Rappel modifié.'
      //     })
      //   })
      // }
    },
    created () {
      this.eventDate = new Date(this.event.date)
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/calendar/CalendarReminderItem.vue